import { lazy } from 'react'
import { createHashRouter, Navigate, type RouteObject } from 'react-router-dom'

import App, { AuthedApp } from './App'
import { NotFound, RequireAuth, RouteError } from './components'
import { RedirectIfAuthed } from './components/redirect-if-authed'
import { isMobile } from './utils'

const Login = lazy(() => import('./pages').then(m => ({ default: m.LoginPage })))
const Projects = lazy(() => import('./pages').then(m => ({ default: m.Projects })))
const ProjectRedirect = lazy(() => import('./pages').then(m => ({ default: m.ProjectRedirect })))
const Settings = lazy(() => import('./pages').then(m => ({ default: m.Settings })))
const ProfileTemplateDetail = lazy(() => import('./pages').then(m => ({ default: m.ProfileTemplateDetail })))
const Preference = lazy(() => import('./pages').then(m => ({ default: m.Preference })))
const Review = lazy(() => import('./pages').then(m => ({ default: m.Review })))
const MobileReview = lazy(() => import('./pages').then(m => ({ default: m.MobileReview })))
const Deliverable = lazy(() => import('./pages').then(m => ({ default: m.Deliverable })))
const Workflows = lazy(() => import('./pages').then(m => ({ default: m.Workflows })))

// 移动端仅放行评审分享页 /review/:token（移动端专用 UI，见 pages/review/mobile）；其余业务路由为桌面端专属，
// 移动端访问未注册路由会落到下方的 * NotFound 兜底。
const authedChildren: RouteObject[] = isMobile()
  ? [{ path: '/review/:token', element: <MobileReview /> }]
  : [
      { index: true, element: <Navigate to="/projects" replace /> },
      {
        path: '/projects/:projectId',
        element: <ProjectRedirect />,
      },
      {
        path: '/projects',
        element: <Projects />,
      },
      {
        path: '/workflows',
        element: <Workflows />,
      },
      {
        path: '/deliverables/:deliverableId',
        element: <Deliverable />,
      },
      {
        path: '/review/:token',
        element: <Review />,
      },
      {
        path: '/settings',
        element: <Settings />,
      },
      {
        path: '/settings/profile-template/:id',
        element: <ProfileTemplateDetail />,
      },
      {
        path: '/preference',
        element: <Preference />,
      },
    ]

export const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <RouteError />,
    children: [
      {
        path: '/login',
        element: (
          <RedirectIfAuthed>
            <Login />
          </RedirectIfAuthed>
        ),
      },
      {
        path: '/',
        element: (
          <RequireAuth>
            <AuthedApp />
          </RequireAuth>
        ),
        children: authedChildren,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
])
